import { EAccountIsFired } from '../types/enum'

export const ACCOUNT_IS_FIRED_COLORS_MAP: Record<EAccountIsFired, string> = {
	[EAccountIsFired.NotFired]: 'bg-grey',
	[EAccountIsFired.Fired]: 'bg-danger'
}